import type { Timestamp } from 'firebase/firestore';

export type WithDates<T> = {
  [K in keyof T]: T[K] extends Timestamp
    ? Date
    : T[K] extends Array<infer U>
    ? Array<WithDates<U>>
    : T[K] extends object
    ? WithDates<T[K]>
    : T[K];
};

export const convertTimestamps = async <T>(data: T): Promise<WithDates<T>> => {
  const { Timestamp } = await import('firebase/firestore');
  if (data instanceof Timestamp) {
    return data.toDate() as WithDates<T>;
  }

  if (Array.isArray(data)) {
    return Promise.all(data.map(convertTimestamps)) as Promise<WithDates<T>>;
  }

  if (data && typeof data === 'object') {
    const result: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(data)) {
      result[key] = await convertTimestamps(value);
    }
    return result as WithDates<T>;
  }

  return data as WithDates<T>;
};
